import { render, staticRenderFns } from "./pageNavigation.vue?vue&type=template&id=54752838"
import script from "./pageNavigation.vue?vue&type=script&lang=js"
export * from "./pageNavigation.vue?vue&type=script&lang=js"
import style0 from "./pageNavigation.vue?vue&type=style&index=0&id=54752838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports